import type { FC } from 'react';
import { CreativeTextsFB } from 'features/cabinet';
import { CabinetTitlePage } from 'components/layout';
import { LinkButton } from 'components/common';
import { Guard, usePermissionGuard } from 'features/login';
import { Add } from '@mui/icons-material';

const CreativeTextsPage: FC = () => {
  const { accessToViewOriginaltextcreative, accessToAddOriginaltextcreative } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToViewOriginaltextcreative} fallback>
      <CabinetTitlePage
        title={'Creative Texts'}
        endAdornment={
          <LinkButton
            to={'/cabinet/facebook/creative-texts/add'}
            title={'Add text'}
            disabled={!accessToAddOriginaltextcreative}
            startIcon={<Add />}
          />
        }
      />
      <CreativeTextsFB />
    </Guard>
  );
};

export default CreativeTextsPage;
